/* Lerween Supply — reveal, hero parallax and glass tilt for lw-* sections. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        entry.target.classList.add('is-in');
        io.unobserve(entry.target);
      }
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
  );

  const init = (root = document) => {
    root.querySelectorAll('[data-lw-reveal]:not(.is-in)').forEach((el) => {
      if (reduce) el.classList.add('is-in');
      else io.observe(el);
    });

    if (reduce || matchMedia('(hover: none)').matches) return;

    root.querySelectorAll('[data-lw-tilt]').forEach((el) => {
      if (el.dataset.lwTiltBound) return;
      el.dataset.lwTiltBound = '1';
      const base = getComputedStyle(el).transform;
      const baseT = base === 'none' ? '' : base;
      el.addEventListener('pointermove', (e) => {
        const r = el.getBoundingClientRect();
        const x = (e.clientX - r.left) / r.width - 0.5;
        const y = (e.clientY - r.top) / r.height - 0.5;
        el.style.transform = `${baseT} perspective(900px) rotateX(${(-y * 8).toFixed(2)}deg) rotateY(${(x * 10).toFixed(2)}deg)`;
      });
      el.addEventListener('pointerleave', () => {
        el.style.transform = '';
      });
    });
  };

  const parallax = () => {
    if (reduce) return;
    const items = [...document.querySelectorAll('[data-lw-parallax]')];
    if (!items.length) return;
    let ticking = false;
    const update = () => {
      ticking = false;
      for (const el of items) {
        const r = el.getBoundingClientRect();
        if (r.bottom < 0 || r.top > innerHeight) continue;
        // Measure the container, move its first child, so the transform never feeds back into the rect.
        const speed = parseFloat(el.dataset.lwParallax) || 0.15;
        const target = el.firstElementChild;
        if (target) target.style.transform = `translate3d(0, ${(-r.top * speed).toFixed(1)}px, 0)`;
      }
    };
    // Horizon scrolls inside .page-wrapper on desktop, so listen in the capture phase to catch any scroller.
    document.addEventListener(
      'scroll',
      () => {
        if (!ticking) {
          ticking = true;
          requestAnimationFrame(update);
        }
      },
      { passive: true, capture: true }
    );
    update();
  };

  init();
  parallax();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();

/* Hero ad slideshow: scroll-snap track with autoplay, arrows and dots. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const setup = (root) => {
    if (root.dataset.lwBound) return;
    root.dataset.lwBound = '1';
    const track = root.querySelector('[data-lw-track]');
    const slides = [...track.children];
    const dots = [...root.querySelectorAll('[data-lw-dot]')];
    if (slides.length < 2) return;
    let index = 0;
    let timer;
    const go = (i) => {
      index = (i + slides.length) % slides.length;
      track.scrollTo({ left: slides[index].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    };
    const mark = () => {
      const i = Math.round(track.scrollLeft / track.clientWidth);
      index = Math.max(0, Math.min(slides.length - 1, i));
      dots.forEach((d, n) => d.setAttribute('aria-selected', String(n === index)));
    };
    const stop = () => clearInterval(timer);
    const start = () => {
      stop();
      if (reduce) return;
      timer = setInterval(() => go(index + 1), parseInt(root.dataset.interval, 10) || 6000);
    };
    track.addEventListener('scroll', () => requestAnimationFrame(mark), { passive: true });
    root.querySelector('[data-lw-prev]')?.addEventListener('click', () => { go(index - 1); start(); });
    root.querySelector('[data-lw-next]')?.addEventListener('click', () => { go(index + 1); start(); });
    dots.forEach((d, n) => d.addEventListener('click', () => { go(n); start(); }));
    root.addEventListener('pointerenter', stop);
    root.addEventListener('pointerleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    start();
  };
  const init = (scope = document) => scope.querySelectorAll('[data-lw-slides]').forEach(setup);
  init();
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();
